import { Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { AgreementsClient } from '@unity/clients';
import { AuthorizeDirective } from '@unity/directives/authorize.directive';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridAgreementUserSharedComponent } from '@unity/shared/grid-agreement-user-shared/grid-agreement-user-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-agreement-users-page',
  imports: [AuthorizeDirective, GridAgreementUserSharedComponent, ActionSharedComponent, PageContainerComponent],
  templateUrl: './list-agreement-users-page.component.html',
  styleUrl: './list-agreement-users-page.component.scss',
})
export class ListAgreementUsersPageComponent {
  private readonly agreementsClient = inject(AgreementsClient);

  public readonly $agreementId = input.required({ alias: 'agreementId', transform: (value: string) => parseInt(value) });

  protected agreementResource = rxResource({
    params: () => {
      const agreementId = this.$agreementId();
      return agreementId ? { agreementId } : undefined;
    },
    stream: ({ params: { agreementId } }) => this.agreementsClient.getOneAsMini(agreementId),
  });

  protected readonly $contentHeaderSecondary = computed(() => {
    const agreement = this.agreementResource.value();
    return `Agreement: ${agreement?.name}`;
  });

  protected readonly $actions = computed(() => {
    const agreementId = this.$agreementId();
    const actions = [];
    if (agreementId) {
      actions.push(QuickActions.CreateAgreementUser(agreementId));
    }
    return actions;
  });
  protected readonly $returnToAgreementAction = computed(() => QuickActions.ReturnToAgreement(this.$agreementId()));
}
